import { Button, Stack } from "@mui/material";
import React, { FunctionComponent, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ChevronLeftIcon, ChevronRightIcon } from "assets";

import { COLORS, Label14SemiBold } from "components";

import { MaybeNull } from "types";

import { UTILITY_BILL_PAGE } from "pages/authenticated/documents/document-summary-v2/route-consts";

import { useSelectedUtilityBills } from "recoils";

interface BillsPaginationProps {
  fileName: MaybeNull<string>;
}

const getPaginationButtonsStyle = ({ disabled }: { disabled: boolean }) => ({
  padding: 0,
  opacity: disabled ? "0.25" : "1",
  svg: { width: 24, height: 24, path: { fill: "#ffffff" } },
});

export const PurchasesPagination: FunctionComponent<
  BillsPaginationProps
> = ({ fileName }) => {
  const selectedPurchases = useSelectedUtilityBills();

  const { billId } = useParams();
  const navigate = useNavigate();

  const PurchasesSelected = selectedPurchases.length
    ? selectedPurchases
    : [billId];

  const currentPurchaseIndex = PurchasesSelected.findIndex(
    (id) => id === billId,
  );

  const isFirstBill = currentPurchaseIndex === 0;
  const isLastBill =
    selectedPurchases.length !== 0
      ? currentPurchaseIndex === selectedPurchases.length - 1
      : true;

  const onPreviousClick = useCallback(() => {
    navigate(
      `${UTILITY_BILL_PAGE.ABSOLUTE_PATH(
        selectedPurchases[currentPurchaseIndex - 1],
      )}`,
    );
  }, [currentPurchaseIndex, navigate, selectedPurchases]);

  const onNextClick = useCallback(
    () =>
      navigate(
        `${UTILITY_BILL_PAGE.ABSOLUTE_PATH(
          selectedPurchases[currentPurchaseIndex + 1],
        )}`,
      ),
    [currentPurchaseIndex, navigate, selectedPurchases],
  );

  return (
    <Stack direction="row" alignItems="center">
      {fileName && <Label14SemiBold>{fileName}</Label14SemiBold>}
      <Button
        sx={getPaginationButtonsStyle({ disabled: isFirstBill })}
        disabled={isFirstBill}
        variant="text"
        onClick={onPreviousClick}
      >
        <ChevronLeftIcon />
      </Button>

      <Stack direction="row" alignItems="center">
        <Label14SemiBold
          sx={{
            minWidth: 50,
            background: "#ffffff",
            marginRight: 1,
            padding: "10px 16px",
            color: COLORS.menuItemColor,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          {currentPurchaseIndex + 1}
        </Label14SemiBold>

        <Label14SemiBold sx={{ marginLeft: "12px", marginRight: "18px" }}>/</Label14SemiBold>

        <Label14SemiBold>{PurchasesSelected.length}</Label14SemiBold>
      </Stack>

      <Button
        sx={getPaginationButtonsStyle({ disabled: isLastBill })}
        disabled={isLastBill}
        variant="text"
        onClick={onNextClick}
      >
        <ChevronRightIcon />
      </Button>
    </Stack>
  );
};
